;(function() {
  'use strict'

  angular.module('core.gSegments', [])
})()
